/**
 * Загрузка Snapshot v2 (narrative-first контракт) с сервера.
 *
 * Единственный snapshot-фасад для Web. v1-контракт полностью снят:
 * на сервере остался только `/api/repo/.../snapshot-v2`, отдельного
 * v1-builder'а и v1-эндпоинта больше нет.
 */

import type { Snapshot } from '@pflow/shared/v2';

export interface LoadSnapshotInput {
    owner: string;
    repo:  string;
    ref?:  string;
    /** Поддиректория для monorepo. */
    path?: string;
}

export async function loadSnapshot(input: LoadSnapshotInput): Promise<Snapshot> {
    const url = new URL(`/api/repo/${input.owner}/${input.repo}/snapshot-v2`, location.origin);
    if (input.ref)  url.searchParams.set('ref',  input.ref);
    if (input.path) url.searchParams.set('path', input.path);
    const res = await fetch(url.pathname + url.search, { credentials: 'include' });
    if (!res.ok) {
        const text = await res.text().catch(() => '');
        throw new Error(`snapshot fetch ${res.status}: ${text || res.statusText}`);
    }
    return await res.json() as Snapshot;
}
